/**
 * BrandLogo — 브랜드 로고 한 장을 놓인 자리에 맞게 그린다.
 *
 *   - SVG(data URL)면 인라인 <svg> 로 넣어 글자색이 CSS `color` 를 따라간다(currentColor). 그래서 어두운 좌측바·로그인
 *     배경에서는 흰 글자, 흰 문서에서는 검은 글자가 한 파일로 나온다. 호출부는 color 만 정하면 된다.
 *   - PNG/JPG 또는 해석 실패면 <img> 폴백(색 자동 대응 없음 — 그런 이미지는 브랜드 화면의 다크 칸에 따로 올린다).
 *   - 크기: 컨테이너(className)가 height 를 정하면 viewBox 비율로 폭이 따라간다(aspect-ratio).
 */
import { useMemo } from "react";
import { parseInlineSvg } from "@/utils/svg_inline";

interface Props {
  src: string;
  alt: string;
  className?: string;
}

export function BrandLogo({ src, alt, className }: Props) {
  const inline = useMemo(() => parseInlineSvg(src), [src]);
  if (!src) return null;
  if (!inline) return <img className={className} src={src} alt={alt} />;
  return (
    <span
      className={`brand-logo-inline${className ? ` ${className}` : ""}`}
      role="img"
      aria-label={alt}
      style={inline.ratio ? { aspectRatio: String(inline.ratio) } : undefined}
      dangerouslySetInnerHTML={{ __html: inline.markup }}
    />
  );
}
